import Button from '@/components/Button';
import { useChapterStore } from '../../../shared/store/useChapterStore';
import { PlayIcon } from '@heroicons/react/24/outline';

export const MediaLinks = () => {
  const chapter = useChapterStore((state) => state.chapter);

  if (!chapter || !chapter?.mediaLinks?.links?.length) return null;

  return (
    <div className="rounded-2xl border border-[#9FC3FA] bg-[#F6F9FF] p-5">
      {chapter?.mediaLinks?.header && (
        <div className="mb-sh-15 flex items-center gap-sh-15">
          {chapter.mediaLinks.header.icon?.url && (
            <img src={chapter.mediaLinks.header.icon.url} alt="" className="size-[38px]" />
          )}
          <h3 className="!mb-0 font-cadiz text-sh-28-32 font-bold">{chapter.mediaLinks.header.title}</h3>
        </div>
      )}
      {chapter?.mediaLinks?.links?.map((link) => {
        if (!link) return null;
        return (
          <div key={link.title} className="mb-sh-15">
            <Button theme="outline" onClick={() => window.open(link.url, '_blank')}>
              <PlayIcon className="size-6" />
              {link.title}
            </Button>
          </div>
        );
      })}
    </div>
  );
};
